<template>
  <div id="app">
    <IndexHeading/>
    <CardAlbum/>
    <br>
  </div>
</template>

<script>
import IndexHeading from '@/components/home/IndexHeading.vue'
import CardAlbum from '@/components/home/CardAlbum.vue'

export default {
  name: 'Index',
  components: {
    IndexHeading,
    CardAlbum
  }
}
</script>

<style>
#app {
  background-color: #3A4861;
  width: 100%;
  font-family: 'Roboto Condensed', sans-serif;
  padding: 0px;
  margin: 0px;
} 



</style>
